import { 
    FETCH_OPTIONS_CHAIN_TICKERS_START,
    FETCH_OPTIONS_CHAIN_TICKERS_SUCCESS,
    FETCH_OPTIONS_CHAIN_TICKERS_FAILURE
} from "../actions/optionChainTickersAction";

const initialState = {
    optionsChainTickers: {},
};


export const OptionsChainTickersReducer = (state = initialState, action) => {
    switch (action.type){
        case FETCH_OPTIONS_CHAIN_TICKERS_START:
            return { ...state, isLoadingChain: true, error: null }; 
        case FETCH_OPTIONS_CHAIN_TICKERS_SUCCESS:
            return { ...state, isLoadingChain: false, optionsChainTickers: { ...state.optionsChainTickers, [action.payload.ticker]: action.payload.details.result }, error: null };
        case FETCH_OPTIONS_CHAIN_TICKERS_FAILURE:
            return { ...state, isLoadingChain: false, error: action.payload.error };
        default:
            return state;
    }

}

export default OptionsChainTickersReducer